export default __webpack_public_path__ + "static/media/DSC_0583.2e2e165e.webp";